import { reactive, ref, readonly, provide, inject, onUnmounted, computed } from 'vue';
export const tabsInjectionKey = Symbol('tabs');
export const useTabs = () => {
    const tabs = reactive(new Map());
    const registerTab = (identifier, tabData) => {
        tabs.set(identifier, tabData);
    };
    const deregisterTab = (identifier) => {
        tabs.delete(identifier);
    };
    const activeTab = ref();
    const activeTabStr = ref("");
    provide(tabsInjectionKey, {
        registerTab,
        deregisterTab,
        activeTab: readonly(activeTab),
    });
    const setActiveTab = (identifier) => {
        activeTab.value = identifier;
        activeTabStr.value = typeof (activeTab.value) !== "undefined" ? activeTab.value.description : "";
    };
    return {
        tabs: readonly(tabs),
        setActiveTab,
        activeTabStr,
        activeTab
    };
};
export const useTab = (tabData) => {
    const tabsInjection = inject(tabsInjectionKey);
    if (!tabsInjection) {
        throw new Error('Tabs were not provided');
    }
    const { registerTab, deregisterTab, activeTab } = tabsInjection;
    const tabSymbol = Symbol(tabData.name);
    registerTab(tabSymbol, tabData);
    onUnmounted(() => {
        deregisterTab(tabSymbol);
    });
    const isActive = computed(() => (activeTab.value === tabSymbol));
    return {
        isActive,
    };
};
//# sourceMappingURL=tabs.js.map